import { FETCH_PERMISSIONS } from "./actions.type";
import { PermissionsService } from "../../common/permissions.service";

const state = {
    status: "",
    permissions: []
};

const getters = {
    permissions(state) {
        return state.permissions;
    }
};

const actions = {
    [FETCH_PERMISSIONS]({ commit }) {
        commit("resetUser");
        return PermissionsService.fetchAll()
            .then(({ data }) => {
                commit("fetchPermissionsSuccess", data);
            })
            .catch(error => {
                throw new Error(error);
            });
    }
};

const mutations = {
    fetchPermissionsSuccess: (state, resp) => {
        state.permissions = resp;
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};
